/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2023-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import {all} from "redux-saga/effects";


const rootSaga = function* () {
    yield all(
        [
        ]
    )
}

export default rootSaga;
